module.exports = __webpack_public_path__ + "img/status_approving_black.f4bada34.png";